module.exports = __webpack_public_path__ + "static/media/CA.a69e8b23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CA.svg
// module id = 216
// module chunks = 0